import { useHasTrackingCode } from '../../../../hooks/usePrerenderUser';
import { useIsAccountExpired } from '../../../../hooks/useIsAccountExpired';
import { useGetDiscoverabilityStatusQuery } from '../api/discoverabilityStatusApi';

export type DiscoverabilityEntitlement =
  | { kind: 'no-integration' }
  | { kind: 'active' }
  | { kind: 'expired-with-data' };

export function useDiscoverabilityEntitlement(): DiscoverabilityEntitlement {
  const hasTrackingCode = useHasTrackingCode();
  const isExpired = useIsAccountExpired();
  const { data } = useGetDiscoverabilityStatusQuery();

  if (!hasTrackingCode) {
    return { kind: 'no-integration' };
  }

  const hasHistoricalData = !!data && data.status !== 'no_data';

  if (isExpired && hasHistoricalData) {
    return { kind: 'expired-with-data' };
  }

  return { kind: 'active' };
}
